import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Container from '@mui/material/Container';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import ProceedButton from '../../../ProceedButton';
import stepFooterStyles from './StepFooter.styles';
import { QuoteBuilderValues } from '../../utils/formState';
import { loadingCartCatalogue$ } from '../../../../store/loading/selectors';
import { submittingAuth$ } from '../../../../store/submitting/selectors';

export interface StepFooterProps {
  onPrevious?: () => void;
  proceedBtnText?: string;
}

function StepFooter({ onPrevious, proceedBtnText = 'Next' }: StepFooterProps) {
  const { classes: stepFooterClasses } = stepFooterStyles();

  const submitting = useSelector(submittingAuth$);
  const loadingCatalogue = useSelector(loadingCartCatalogue$);

  const { isValid, submitCount } = useFormikContext<QuoteBuilderValues>();

  const loading = !!submitCount && (submitting || loadingCatalogue);

  /** Disabled next button if user has attmpeted a submit AND form is NOT valid or submitting. */
  const disabledProceedBtn = !!submitCount && (!isValid || loading);

  return (
    <footer className={stepFooterClasses.footer}>
      <Container className={stepFooterClasses.containerFooter}>
        <Box display={{ xs: 'none', sm: 'inline' }}>
          {!!onPrevious && (
            <Button
              disabled={submitting}
              variant="contained"
              onClick={onPrevious}
              startIcon={<ChevronLeftIcon />}
              size="medium"
            >
              Back
            </Button>
          )}
        </Box>
        {/* We're transitioning between pages so this should be a type="submit" */}
        <ProceedButton
          disabled={disabledProceedBtn}
          type="submit"
          color="primary"
          variant="contained"
          size="medium"
          loading={loading}
          className={stepFooterClasses.buttonNext}
          endIcon={<ChevronRightIcon>proceed</ChevronRightIcon>}
        >
          {proceedBtnText}
        </ProceedButton>
      </Container>
    </footer>
  );
}

export default StepFooter;
